export default "__VITE_ASSET__D56W$eO0__"